import { render } from "./InsuranceSettings.vue?vue&type=template&id=b6cdea4e&scoped=true"
import script from "./InsuranceSettings.vue?vue&type=script&lang=js"
export * from "./InsuranceSettings.vue?vue&type=script&lang=js"

import "./InsuranceSettings.vue?vue&type=style&index=0&id=b6cdea4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6cdea4e"]])

export default __exports__